export const GET_INDICATORS_SUCCESS = "GET_INDICATORS_SUCCESS";
export const GET_INDICATORS_FAILURE = "GET_INDICATORS_FAILURE";
export const GET_INDICATORS_STARTED = "GET_INDICATORS_STARTED";
